// Fetching existing chatbots from user
export const SUCCESSFUL_CHATBOT_FROM_USER_FETCH =
  'SUCCESSFUL_CHATBOT_FROM_USER_FETCH';

// Creating a new quizbot
export const NEW_QUIZBOT_CREATED = 'NEW_QUIZBOT_CREATED';
